module.exports = __webpack_public_path__ + "static/media/Events.98a6ca35.jpg";